import type { RouteConfig } from '@shared/types/common.types';

import { PUBLIC_APPOINTMENT_ROUTES } from './Appointment/public-routes';
import { APPOINTMENT_ROUTES } from './Appointment/routes';
import { APPOINTMENT_BOOK_NEXT_ROUTES } from './AppointmentBookNext/routes';
import { APPOINTMENT_NEW_ROUTES } from './AppointmentMakeNew/routes';
import { MOBILE_REGISTRATION_ROUTES } from './MobileRegistration/routes';
import { QUESTIONNAIRE_ROUTES } from './Questionnaire/routes';
import { APPOINTMENT_ACCOMPANYING_VISITOR_ROUTES } from './VisitorManagement/routes';

export const APPOINTMENT_GROUP_ROUTES: RouteConfig[] = [
  ...APPOINTMENT_ROUTES,
  ...APPOINTMENT_BOOK_NEXT_ROUTES,
  ...PUBLIC_APPOINTMENT_ROUTES,
  ...APPOINTMENT_NEW_ROUTES,
  ...QUESTIONNAIRE_ROUTES,
  ...MOBILE_REGISTRATION_ROUTES,
  ...APPOINTMENT_ACCOMPANYING_VISITOR_ROUTES,
];
